import {UserProfessionalProfile, UserWorkableArea} from '../../../../functions/src/data';
import {Actions, ActionTypes} from './actions';
import {ProfessionalPortfolioModel} from '../../../../functions/src/data/portfolio-model';


export interface State {
  formData?: {
    data?: UserProfessionalProfile;
    isValid: boolean;
    isNewProfile: boolean;
    hasChanges: boolean;
    oldWorkableAreas: UserWorkableArea[];
  };
  portfolioList?: ProfessionalPortfolioModel[];
}

export const initialState: State = {
  formData: null,
  portfolioList: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.Init:
      return state;

    case ActionTypes.CreateProfessionalProfile:
      return {
        ...state,
        formData: {
          data: {
            uid: action.payload.uid,
            isActive: true,
            logoUrl: action.payload.photoUrl,
            name: action.payload.name,
            description: '',
            address: action.payload.address,
            country: action.payload.country,
            city: action.payload.city,
            vatNumber: action.payload.vatNumber,
            phoneNumber: {
              number: action.payload.phoneNumber,
              validated: false
            },
            documents: [],
            remoteWork: false,
            skills: [],
            websiteUrls: [],
            workableAreas: []
          },
          isValid: false,
          isNewProfile: true,
          hasChanges: true,
          oldWorkableAreas: []
        }
      };
    case ActionTypes.LoadProfessionalProfileResult:
      if (action.payload.isSuccess) {
        return {
          ...state,
          formData: {
            ...state.formData,
            data: action.payload.responseData,
            isValid: true,
            isNewProfile: false,
            hasChanges: false,
            oldWorkableAreas: action.payload.responseData.workableAreas
          }
        };
      }
      break;
    case ActionTypes.SaveProfessionalProfileResult:
      return {
        ...state,
        formData: {
          ...state.formData,
          hasChanges: false
        }
      };
    case ActionTypes.UpdateProfessionalProfileForm:
      return {
        ...state,
        formData: {
          ...state.formData,
          data: action.payload.data,
          isValid: action.payload.isValid,
          hasChanges: true
        }
      };
    case ActionTypes.UpdateProfessionalWorkAreasFormResult:
      return {
        ...state,
        formData: {
          ...state.formData,
          data: {
            ...state.formData.data,
            workableAreas: action.payload
          },
          hasChanges: true
        }
      };
    case ActionTypes.AddProfessionalSkill:
      // Check if should add the new skill
      if (state.formData.data.skills && action.payload) {

        for (const skill of state.formData.data.skills) {
          if (skill.category.id === action.payload.category.id && skill.skill.id === action.payload.skill.id) {
            // Not added
            return state;
          }
        }
        // If it reached here, means that doesn't exists yet
        state.formData.data.skills.push(action.payload);
        state.formData.hasChanges = true;
      }

      return state;

    case ActionTypes.RemoveProfessionalSkill:
      if (action.payload.skillId && action.payload.skillId) {
        state.formData.data.skills = state.formData.data.skills.filter(value => {
          return value.skill.id !== action.payload.skillId && value.category.id !== action.payload.categoryId;
        });
        state.formData.hasChanges = true;
      }
      return state;
    case ActionTypes.LoadPortfolioListResult:
      return {
        ...state,
        portfolioList: action.payload.list
      };
  }
  return state;
}

// Pure Functions
export const getFormData = (state: State) => state.formData;
export const getPortfolioList = (state: State) => state.portfolioList;
export const getProfessionalProfile = (state: State) => state.formData.data;
export const getIsFormValid = (state: State) => state.formData.isValid;
export const hasFormChanges = (state: State) => state && state.formData ? state.formData.hasChanges : false;
